import * as React from "react";
import { MyCard } from "../MyCard";
import { Fee } from "./Fee";
import { shortHash } from "../ui";

export function TransactionDetails({ config, transaction }) {
  const dateISOString = transaction.blocktime
    ? new Date(transaction.blocktime * 1000).toISOString()
    : "";
  const dateLocaleString = transaction.blocktime
    ? new Date(transaction.blocktime * 1000).toLocaleString()
    : "";

  return (
    <MyCard
      header="Details"
      body={
        <div className="stack">
          <dl className="kv">
            <dt>Local time</dt>
            <dd>{dateLocaleString || "mempool"}</dd>
            <dt>ISO</dt>
            <dd>{dateISOString || "—"}</dd>
            <dt>Inputs / outputs</dt>
            <dd>
              {transaction.vin.length} / {transaction.vout.length}
            </dd>
            <dt>Block</dt>
            <dd>
              {transaction.blockhash ? (
                <a href={"index.html?route=BLOCK&hash=" + transaction.blockhash}>
                  {transaction.height != null && transaction.height !== 0
                    ? transaction.height.toLocaleString()
                    : shortHash(transaction.blockhash)}
                </a>
              ) : (
                "unconfirmed"
              )}
            </dd>
            <dt>Confirmations</dt>
            <dd>{(transaction.confirmations || 0).toLocaleString()}</dd>
          </dl>
          <Fee
            transaction={transaction}
            baseCurrency={config ? config.baseCurrency : "TLS"}
          />
        </div>
      }
    />
  );
}
